import React from 'react';
import { CircleCheckIcon } from './Icons';
export const HeroSection = () => {
  return <section className="w-full bg-gradient-to-b from-light to-white" data-id="element-90">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6 py-6 md:py-10" data-id="element-91">
        <div className="flex flex-col md:flex-row md:items-start gap-8 md:gap-10" data-id="element-92">
          {/* Left Column (55% on desktop) — label, H1, sub, CTA, trust line */}
          <div className="w-full md:w-[55%] flex flex-col items-center text-center order-1" data-id="element-93">
            <span className="block w-full font-lato font-bold uppercase text-medium text-center" style={{
            fontSize: '13px',
            letterSpacing: '0.2em',
            marginBottom: '16px'
          }} data-id="element-94">
              DISCOVER THE SYSTEM
            </span>

            <h1 className="block w-full font-playfair text-primary text-center" style={{
            fontSize: 'clamp(32px, 5vw, 52px)',
            lineHeight: 1.15,
            marginBottom: '20px',
            maxWidth: '600px',
            marginLeft: 'auto',
            marginRight: 'auto'
          }} data-id="element-95">
              What If Your Tests Say Normal... But You Know Something Is Very
              Wrong?
            </h1>

            <p className="block font-lato text-secondary text-center" style={{
            fontSize: 'clamp(17px, 1.6vw, 20px)',
            lineHeight: 1.6,
            marginBottom: '32px',
            maxWidth: '560px',
            marginLeft: 'auto',
            marginRight: 'auto'
          }} data-id="element-96">
              The 30-day method that helps women like you restore their energy
              and calm their symptoms — without medication, extreme diets, or
              expensive protocols.
            </p>

            {/* CTA Button — immediately after subheadline */}
            <a href="#final-cta" className="font-lato font-bold uppercase text-white bg-medium hover:bg-primary transition-colors duration-300 text-center no-underline" style={{
            display: 'block',
            fontSize: '18px',
            padding: '22px 48px',
            borderRadius: '50px',
            boxShadow: '0 8px 24px rgba(149,125,173,0.4)',
            marginBottom: '16px',
            width: '100%',
            maxWidth: '420px'
          }} data-id="element-97">
              YES, I WANT INSTANT ACCESS
            </a>

            {/* Trust line */}
            <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 font-lato text-center" style={{
            fontSize: '13px',
            color: '#777777'
          }} data-id="element-98">
              <div className="flex items-center gap-1.5" data-id="element-99">
                <CircleCheckIcon color="#957DAD" size={14} data-id="element-100" />
                <span data-id="element-101">Instant Access</span>
              </div>
              <span className="hidden md:inline text-accent" data-id="element-102">|</span>
              <div className="flex items-center gap-1.5" data-id="element-103">
                <CircleCheckIcon color="#957DAD" size={14} data-id="element-104" />
                <span data-id="element-105">4 Products Included</span>
              </div>
              <span className="hidden md:inline text-accent" data-id="element-106">|</span>
              <div className="flex items-center gap-1.5" data-id="element-107">
                <CircleCheckIcon color="#957DAD" size={14} data-id="element-108" />
                <span data-id="element-109">30-Day Guarantee</span>
              </div>
            </div>
          </div>

          {/* Right Column (45% on desktop) — image only, top-aligned. BELOW left column on mobile */}
          <div className="w-full md:w-[45%] order-2" style={{
          marginTop: 0
        }} data-id="element-110">
            <img src="https://cdn.magicpatterns.com/uploads/dSC3DRJpoRRB6r6dLZKocb/HERO.png" alt="Woman at her desk reviewing The Hormonal Balance Code on her devices" className="w-full h-auto rounded-[16px] shadow-[0_16px_48px_rgba(149,125,173,0.2)] object-cover mt-8 md:mt-0" data-id="element-111" />
          </div>
        </div>
      </div>
    </section>;
};